import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Modal from '../components/Modal';
import Input from '../components/Input';

export default function TestMessageModal({
  open,
  onCancel,
  onConfirm,
  testToNumber,
  onChangeToNumber,
  testMessage,
  onChangeMessage,
  testError,
  testMessageUuid,
}) {
  return (
    <Modal
      open={open}
      title="Send a test message"
      ctaButtonText="Send"
      cancelButtonText={testMessageUuid ? 'Close' : 'Cancel'}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className="space-y-4">
        <Input
          label="To phone number"
          placeholder="e.g. 14082132000"
          required
          type="tel"
          value={testToNumber}
          onChange={(e) => onChangeToNumber(e.target.value)}
        />
        <Input
          as="textarea"
          label="Message"
          placeholder="Enter your test message..."
          required
          rows={3}
          value={testMessage}
          onChange={(e) => onChangeMessage(e.target.value)}
        />

        {testError && (
          <div className="rounded-md bg-red-50 p-4 dark:bg-red-950">
            <div className="flex">
              <div className="shrink-0">
                <ExclamationTriangleIcon aria-hidden="true" className="size-5 text-red-400 dark:text-red-500" />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-red-800 dark:text-red-300">{testError}</p>
              </div>
            </div>
          </div>
        )}

        {testMessageUuid && (
          <div className="rounded-md bg-green-50 dark:bg-green-950 p-4">
            <p className="text-sm font-medium text-green-800 dark:text-green-300 mb-1">
              Message sent successfully!
            </p>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-green-700 dark:text-green-400 font-medium">Message ID:</span>
              <code className="text-xs px-2 py-0.5 rounded bg-green-100 dark:bg-green-900 text-green-900 dark:text-green-100 font-mono break-all">
                {testMessageUuid}
              </code>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
